import React from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import classnames from "classnames";

// import { format } from "date-fns";

import { H } from "@lifepay/rc-ui-toolkit";

// import Labeled from "components/visual/Labeled";
// import Badge from "components/visual/Badge";
// import CardSmsControl from "../controls/CardSmsControl";

import LimitGroup from "../LimitGroup";
// import cardtype from "./cardtype";
import styles from "./CardLimits.m.scss";

function CardLimits(props) {
  const { theme, cardId, groupedLimits, loading, loaded } = props;

  if (loading) {
    return null;
  }

  return (
    <div className={classnames(theme.wrapper)}>
      <div className={classnames(theme.inner)}>
        <div className={classnames(theme.header)}>
          <H t="h4">{"Лимиты по карте"}</H>
          <div className={classnames(theme.hint)}>
            {"осталось / всего (израсходовано)"}
          </div>
        </div>
        {loaded &&
          groupedLimits.map((limitGroup) => {
            return (
              <LimitGroup
                key={"limitGroup" + limitGroup.id}
                groupId={limitGroup.id}
                groupName={limitGroup.name}
                limits={limitGroup.limits}
              />
            );
          })}
      </div>
    </div>
  );
}

CardLimits.displayName = "CardLimits";

CardLimits.propTypes = {
  theme: PropTypes.object,
  cardId: PropTypes.string,
  groupedLimits: PropTypes.array,
  limitGroups: PropTypes.array,
  loading: PropTypes.bool,
  loaded: PropTypes.bool,
};

CardLimits.defaultProps = {};

export default themr("@lifepay/CardLimits", styles)(CardLimits);



// WEBPACK FOOTER //
// ./src/components/emission/cards/limits/CardLimits/CardLimits.js